import { Label } from 'lib/Label';
import React from 'react';
import NavigationTile from '../NavigationTile';
import useObjectiveFilters from './useObjectiveFilters';
import NavigationButton from '../NavigationButton';

const ObjectiveFilters: React.FC = () => {
  const { filledFilters, emptyFilters } = useObjectiveFilters();

  return (
    <div data-test-id="objective-panel-filters-section">
      <Label label="Filters" />
      {filledFilters.length ? (
        <div className="flex flex-col gap-y-2 mb-4">
          {filledFilters.map(({ label, svg, onClick, included, excluded }) => (
            <NavigationButton
              key={label}
              buttonLabel={label}
              buttonIcon={svg}
              onClick={onClick}
              includedFilters={included}
              excludedFilters={excluded}
            />
          ))}
        </div>
      ) : null}
      <div className="grid grid-cols-3 gap-2">
        {emptyFilters.map(({ label, svg, onClick, isDisabled }) => (
          <NavigationTile key={label} label={label} svg={svg} onClick={onClick} isDisabled={isDisabled} />
        ))}
      </div>
    </div>
  );
};

export default ObjectiveFilters;
